// Side-effect module: registers the `toolBridge` namespace into i18next.
// Imported by the free audio tool pages that carry a track into the
// music-video generator, and by DirectorHome (where that track lands). Same
// ordering-safe pattern as registerClipChangeScopeI18n.ts.
import i18n from "../i18n";
import toolBridge from "./toolBridge";

for (const [code, data] of Object.entries(toolBridge)) {
  i18n.addResourceBundle(
    code,
    "translation",
    { toolBridge: data },
    true,
    true,
  );
}
